var map = {
	"./addresses.svg": 370,
	"./affiliate-overview.svg": 1974,
	"./bank-transactions.svg": 3378,
	"./coin-transactions.svg": 2517,
	"./orders.svg": 5621,
	"./transfer.svg": 5373,
	"./wages-list.svg": 1345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5138;